import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { useAdminAuth } from './AdminAuthContext'; // You already have this!
import { useAffiliateAuth } from './AffiliateAuthContext'; // We'll create this next!

const AffiliateProtectedRoute = ({ component: Component, ...rest }: RouteProps & { component: React.ComponentType<any> }) => {
    const { isAdmin, isLoading: isAdminLoading } = useAdminAuth();
    const { isAffiliate, isLoading: isAffiliateLoading } = useAffiliateAuth();

    if (isAdminLoading || isAffiliateLoading) {
        return <div>Loading...</div>; // Show a spinner while we check both
    }

    return (
        <Route
            {...rest}
            render={props =>
                (isAdmin || isAffiliate) ? (
                    <Component {...props} />
                ) : (
                    <Redirect to="/ar" /> // Or to an access denied page
                )
            }
        />
    );
};

export default AffiliateProtectedRoute;